import * as React from 'react';
import { useContext, useEffect, useRef, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import { pipe } from 'fp-ts/es6/pipeable';
import * as TE from 'fp-ts/es6/TaskEither';
import { UserContext } from '@amzn/aapn-front-end-login-lib';
import { initApolloClient, MAX_REQUEST_ATTEMPTS, MAX_REQUEST_DURATION } from './apollo_client_helper';
import styled from 'styled-components';
export const CLIENT_LOADING = 'Client loading...';
const handleError = (reason) => new Error(JSON.stringify(reason, null, 2));
const LoadingMessage = styled.div `
  height: 100vh;
  line-height: 100vh;
  text-align: center;
  font-family: ${({ theme }) => theme.globals.bodyFontFamily};
  font-size: ${({ theme }) => theme.typography.size.medium};
`;
export const createAAPNApolloClient = (user, apiEndpoint, headerOptions, possibleTypes, includeCredentials, maxRetryCount = MAX_REQUEST_ATTEMPTS, maxTimeoutDuration = MAX_REQUEST_DURATION, enableRetries = true, enableTimeout = true, performanceCallback = undefined) => {
    return TE.tryCatch(() => initApolloClient(user, apiEndpoint, headerOptions, possibleTypes, includeCredentials, maxRetryCount, maxTimeoutDuration, enableRetries, enableTimeout, performanceCallback), handleError);
};
export const AAPNApolloProvider = (props) => {
    //User should be decoupled from this and moved to props. Bad coupling.
    const user = useContext(UserContext);
    //Client is null until it's ready.
    const [client, setClient] = useState(null);
    const isInitialRender = useRef(true);
    const createClient = pipe(createAAPNApolloClient(user, props.apiEndpoint, props.headerOptions, props.possibleTypes, props.includeCredentials, props.maxRetryCount, props.maxTimeoutDuration, props.enableRetries, props.enableTimeout, props.performanceCallback), TE.map(setClient), TE.getOrElse(error => {
        throw error;
    }));
    useEffect(() => {
        if (isInitialRender.current) {
            // First time execution
            isInitialRender.current = false;
        }
        else {
            // Subsequent executions
            setClient(null);
        }
    }, [user === null || user === void 0 ? void 0 : user.id_token]);
    if (client) {
        return React.createElement(ApolloProvider, { client: client }, props.children);
    }
    else {
        createClient();
        return React.createElement(LoadingMessage, null, CLIENT_LOADING);
    }
};
